import React, { Component } from 'react';
import { connect } from 'react-redux';
import OwlCarousel from 'react-owl-carousel2';
import axios from 'axios';
import Loader from 'react-loader-spinner';
import Layout from '../layout/Layout';
import Callusnow from './Callusnow';
import $ from 'jquery';  
import { Redirect, Link, withRouter } from 'react-router-dom';



const API_URL = process.env.REACT_APP_API_URL;

var fs = require('browserify-fs');

class Programmedetails extends Component {
	
	constructor(props) {
        super(props);
 
        this.state = {
          	loaded: true,
            ProgrammeDetails:[],
            ProgrammeImages:[],
			languagedata:[],
			defaultlang:6,
			Programmes:[],
			AllProgrammesCount:0,
			AllCityCount:0,
			AllStateCount:0,


			
			
        };
		
    }
componentDidMount() {
	//console.log(this.props.match.params.id);
	$('html, body').animate({
		scrollTop:0
		}, 1000);
	
   
}

componentWillMount() {
  
    
    const deflang= localStorage.getItem('DefaultLanguage');
        if(deflang == null){
           localStorage.setItem('DefaultLanguage',6);
        }

    const DefaultLang = localStorage.getItem('DefaultLanguage');
    this.setState({defaultlang: DefaultLang});


	const programmeid= this.props.match.params.id;
	
      this.getlanguage(DefaultLang);
    this.getprogrammedetails(programmeid,DefaultLang);
  }

getprogrammedetails(programmeid,DefaultLang){
	 axios.post(`${API_URL}/getprogrammedetails`, 
	 	{ 
	 		LanguageId:DefaultLang,
	 		ProgrammeId:programmeid
	 	})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const ProgrammeDetails = res.data.ResponseData.ProgrammeDetails;
            const ProgrammeImages = res.data.ResponseData.ProgrammeImages;
            const mythis=this;
            this.setState({ ProgrammeDetails }); 
			this.setState({ ProgrammeImages });
            
                     
            
          }else{
          	this.setState({ ProgrammeDetails:[] }); 
			this.setState({ ProgrammeImages:[] });
          }
          this.setState({ loaded: false });
          })
}
getlanguage(defaultlang){
    
   
    axios.post(`${API_URL}/langfile`, { LangId:defaultlang})
        
        .then(res => {
       
          if(res.data.Status == 1)
          {
            const language = res.data.ResponseData;
            let data = res.data.ResponseData[0];
           
             const mythis=this;
             this.setState({ language }); 

              this.setState({languagedata: data});
             
           this.setState({ loaded: false });
                     
            
          }
          })
        
        
        
}	

	

	

  render() {

	  const options = {
			
		    dots:false,
		    loop: true,
		    autoplay: true,
		    margin:5,
			responsive: {
               0: {
				items: 1,
				nav: true
				},
				600: {
				  items: 3,
				  nav: false
				},
				1000: {
				  items: 6,
				  nav: true
				}
             }
		};
	  
	  
    return (
      <div className="App">
	  
          <Layout languagedata={this.state.languagedata}>
	  {this.state.loaded == true ? (	  
		 
	<div className="divloader"> 
		 <Loader 
			 type="ThreeDots"
			 color="#00BFFF"
			 height="100"	
			 width="100"
		  />		  
	 </div>
	
	) : '' }
	<section className="banner inner_banner">
	  <div className="bd-example">
	    <div id="carouselExampleCaptions" className="carousel slide" data-ride="carousel">
	      <div className="carousel-inner">
	        <div className="carousel-item active">
	          <img src={this.state.ProgrammeDetails.ProgrammeBannerImage} className="d-block w-100" alt="..." />
	          <div className="carousel-caption d-none d-md-block">
	            <aside>{this.state.ProgrammeDetails.ProgrammeTitle}</aside>
	          </div>
	        </div>
	      </div>
	    </div>
	  </div>
	</section>
	
		<section className="about new-prgm-detail">
		  <div className="container">
		    <div className="row">
		        
		        <div className="col-xl-5 col-lg-5 col-md-12">
		        	<img src={this.state.ProgrammeDetails.ProgrammeImage} alt=""/>
		        </div> 


<div className="col-xl-7 col-lg-7 col-md-12"><p>{this.state.ProgrammeDetails.ProgrammeDescription}</p>

<h6 className="prgram-h6">{this.state.languagedata.Why_this_Place}</h6> 
<p> {this.state.ProgrammeDetails.Programmeothers}</p>
    
    
    
    <div className="state-data">
    
    <ul className="">
    
        <li><span>{this.state.languagedata.Area}</span>{this.state.ProgrammeDetails.ProgrammeCity}</li>
        <li><span>{this.state.languagedata.State}</span>{this.state.ProgrammeDetails.ProgrammeState}</li>
        <li><span>{this.state.languagedata.Date}</span>{this.state.ProgrammeDetails.ProgrammeDate}</li>
        <li><span>{this.state.languagedata.Volunteers}</span>{this.state.ProgrammeDetails.ProgrammeVolunteers}</li></ul>
    
    
    </div></div>


		        
		     
		    </div>
		  </div>
		</section>
	<section className="programe">
<div className="container">
<div className="row">
<div className="col-12">
<ul className="list-unstyled">
{ this.state.ProgrammeImages.map((impact, key) => 
		    <li>
  				<div class="pro_img">
		        <img src={impact.ProgrammeImage} alt=""/>
		        	
		      	</div>
		      	
			</li>
		      )}

</ul>
</div>
</div>
</div>
</section>

<section className="programe_two">
<div className="container">
<div className="row">
<div className="col-12">
<h3>{this.state.languagedata.our_impact}</h3>
</div>
</div>
<div className="row">
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>{this.state.languagedata.People_Benefited}</aside>
<span>{this.state.ProgrammeDetails.ProgrammePeopleBenefited}</span>
	
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>{this.state.languagedata.Area_Cover}</aside>
<span>{this.state.ProgrammeDetails.ProgrammeAreaCover} <div>km</div> </span>
	
</div>
</div>
<div className="col-xl-4 col-lg-4 col-md-4">
<div className="program_box">
<aside>{this.state.languagedata.Youths_Trained}</aside>
<span>{this.state.ProgrammeDetails.ProgrammeYouthsTrained}</span>
	
</div>
</div>
</div>
</div>
</section>

		<Callusnow languagedata={this.state.languagedata} />
		
      </Layout>
      </div>
    );
  }
}

export default Programmedetails;



// WEBPACK FOOTER //
// ./src/component/Programmedetails.js